import { Pipe, PipeTransform } from '@angular/core';

/**
 * Stabilises rotating S3 presigned image URLs.
 *
 * Headshot URLs are presigned and re-signed on every request, so the query
 * string (the signature) changes each time even though the underlying object
 * is identical. The browser caches by full URL, so a new signature forces a
 * re-download - the speaker/rep headshots visibly "reload" on the event
 * details page and in the person popover.
 *
 * This pipe remembers the first signed URL seen for each S3 object (keyed by
 * the path, i.e. everything before the query string) and always returns that
 * same URL, so the browser keeps serving the already-cached image instead of
 * re-downloading it. Two different objects keep different keys, so they never
 * collide. The cache lives for the app session; a full page reload picks up
 * fresh URLs (a stable URL across reloads would need a backend change).
 */
@Pipe({ name: 'stableImg' })
export class StableImgPipe implements PipeTransform {
  private static cache = new Map<string, string>();

  transform(url: string): string {
    if (!url || !/^https?:\/\//.test(url)) {
      return url;
    }
    const key = url.split('?')[0];
    if (!StableImgPipe.cache.has(key)) {
      StableImgPipe.cache.set(key, url);
    }
    return StableImgPipe.cache.get(key);
  }
}
